<style>
.search_list .v-list .v-list__tile {
    font-weight: normal !important;
}
.search_list .tile {
    margin: 0px;
    border-radius: 4px;
}
/* .search_list .v-list__tile {
    height: 28px !important;
} */
.search_list .v-list__tile--active {
    background: #e0e0e0 !important;
    border-color: #e0e0e0 !important;
}
</style>
<template>
    <v-flex xs12 md3 lg2 align-self-start pb-0>
        <v-card elevation="0">
            <v-toolbar dark :color="searchFilter ? 'orange' : 'primary'">
                <v-toolbar-title>
                    <v-text-field v-model="searchFilter" label="Search" :hide-details="true" clearable @click:clear="filterClearInput()"></v-text-field>
                </v-toolbar-title>
            </v-toolbar>
            <vue-perfect-scrollbar
                :class="['scroll-area search_list', items.length <= 0 ? 'd-flex' : '']"
                :style="$bp.xs ? null : `max-height: calc(100vh - ${height}); min-height: calc(100vh - ${height})`"
            >
                <v-list v-if="items.length > 0">
                    <v-list-tile
                        class="tile"
                        active-class="v-list__tile--active"
                        :value="isActiveMenu(item[`${$attrs['item-value']}`])"
                        v-for="item in resultQuery(items)"
                        :key="item[`${$attrs['item-value']}`]"
                        @click="executeClickMethod(item)"
                    >
                        <v-list-tile-content class="pa-2">
                            <v-list-tile-title v-text="item[`${$attrs['item-text']}`]"></v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <span v-else class="w-100 align-self-center text-center grey--text text--lighten-1">{{ emptyMessage }}</span>
            </vue-perfect-scrollbar>
        </v-card>
    </v-flex>
</template>
<script>
import { store } from "Store/store";

export default {
    name: "bc-search-list",
    props: {
        filter: {
            type: String,
            default: "",
        },
        items: {
            type: Array,
            default: () => [],
        },
        selected_id: {
            type: [String, Number],
            default: 0,
        },
        clickMethod: {
            type: Function,
            required: true,
        },
        height: {
            type: String,
            default: "250px",
        },
        emptyMessage: {
            type: String,
            default: "No data found",
        },
    },
    data() {
        return {
            searchFilter: this.filter,
        };
    },
    methods: {
        executeClickMethod(item = null) {
            if (item != null) {
                this.clickMethod(item);
            } else {
                this.clickMethod();
            }
        },
        resultQuery() {
            if (this.searchFilter) {
                return this.items.filter((item) => {
                    return this.searchFilter
                        .toLowerCase()
                        .split(" ")
                        .every((v) => item[`${this.$attrs["item-text"]}`].toLowerCase().includes(v));
                });
            } else {
                return this.items;
            }
        },
        isActiveMenu(id) {
            return id == this.selected_id;
        },
    },
};
</script>
